/* ============================================
   EXIT-INTENT POPUP JS (Layer B)
   Conditional content based on visitor behaviour.
   Uses real Shopify customer form for CAPTCHA.
   ============================================ */
(function () {
  'use strict';

  /* --- Wait for utility --- */
  if (typeof window.LiftSetsCapture === 'undefined') return;
  var LS = window.LiftSetsCapture;

  /* --- Refs --- */
  var overlay, form, emailInput, tagsInput, submitBtn, btnText, btnLoading, errorEl;
  var activeVariant = null;
  var isDiscount = false;

  /* --- Excluded pages --- */
  function isExcludedPage() {
    var p = window.location.pathname;
    return p.startsWith('/cart') || p.startsWith('/checkout') || p.startsWith('/account');
  }

  /* --- Suppression logic --- */
  function shouldShow() {
    if (LS.hasSubmitted()) return false;
    if (window.__liftsets_logged_in) return false;
    if (isExcludedPage()) return false;
    if (LS.getSession('liftsets_exit_shown')) return false;

    /* Don't show if welcome popup was dismissed recently and few pages viewed */
    if (LS.getSession('liftsets_popup_dismissed_session')) {
      var views = parseInt(LS.getSession('liftsets_page_views') || '0', 10);
      if (views < 2) return false;
    }

    /* 7-day cooldown after dismissal */
    var dismissed = LS.getLocal('liftsets_exit_dismissed');
    if (dismissed) {
      var hours = (Date.now() - parseInt(dismissed, 10)) / 3600000;
      if (hours < 168) return false;
    }

    return true;
  }

  /* --- Determine which variant to show --- */
  async function pickVariant() {
    /* Check UTM for brand search (suppress discount) */
    var params = new URLSearchParams(window.location.search);
    var isBrandSearch = params.get('utm_source') === 'google' &&
      (params.get('utm_campaign') || '').toLowerCase().includes('brand');

    /* Priority 1: Cart has items */
    try {
      var cartResp = await fetch('/cart.js');
      var cart = await cartResp.json();
      if (cart.item_count > 0) return 'cart';
    } catch (e) {}

    /* Priority 2: Viewing £300+ product */
    var price = window.__liftsets_exit_product_price || 0;
    if (price >= 30000) return 'highvalue'; /* Shopify prices in pence */

    /* Priority 3: Repeat visitor with discount */
    var visits = LS.getVisitCount();
    if (visits >= 2 && !isBrandSearch) return 'discount';

    /* Priority 4: Default */
    return 'default';
  }

  /* --- Show popup --- */
  async function showExitIntent() {
    if (!shouldShow()) return;

    overlay = document.getElementById('ls-exit-overlay');
    if (!overlay) return;

    LS.setSession('liftsets_exit_shown', '1');

    var variant = await pickVariant();
    activeVariant = variant;

    /* Show correct variant */
    var variantEl = document.getElementById('ls-exit-' + variant);
    if (variantEl) variantEl.style.display = 'block';

    /* Update button text and tags for discount variant */
    submitBtn = document.getElementById('ls-exit-submit');
    btnText = overlay.querySelector('.ls-exit-btn-text');
    tagsInput = document.getElementById('ls-exit-tags');

    if (variant === 'discount') {
      isDiscount = true;
      if (btnText) btnText.textContent = 'GET 5% OFF';
      if (tagsInput) tagsInput.value = 'exit-intent, exit-discount';
    } else if (variant === 'cart') {
      if (tagsInput) tagsInput.value = 'exit-intent, exit-cart-saver';
    } else if (variant === 'highvalue') {
      if (tagsInput) tagsInput.value = 'exit-intent, exit-high-value';
    } else {
      if (tagsInput) tagsInput.value = 'exit-intent';
    }

    /* Show overlay */
    overlay.style.display = 'flex';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('ls-exit-visible');
      });
    });

    LS.lockScroll();

    /* Fire GA4 event */
    LS.fireEvent('popup_shown', { popup_type: 'exit', variant: variant });
  }

  /* --- Close popup --- */
  function closePopup(method) {
    if (!overlay) return;
    overlay.classList.remove('ls-exit-visible');
    setTimeout(function () {
      overlay.style.display = 'none';
    }, 300);

    LS.unlockScroll();
    LS.setLocal('liftsets_exit_dismissed', String(Date.now()));

    LS.fireEvent('popup_closed', { popup_type: 'exit', method: method || 'unknown' });
  }

  /* --- Init --- */
  function init() {
    overlay = document.getElementById('ls-exit-overlay');
    if (!overlay) return;

    form = document.getElementById('ls-exit-form');
    emailInput = document.getElementById('ls-exit-email');
    errorEl = document.getElementById('ls-exit-error');

    /* Close handlers */
    var closeBtn = overlay.querySelector('.ls-exit-close');
    if (closeBtn) closeBtn.addEventListener('click', function () { closePopup('x_button'); });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup('overlay');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display === 'flex') closePopup('escape');
    });

    /* Form submission */
    if (form) {
      form.addEventListener('submit', async function (e) {
        /* Validate before letting Shopify handle it */
        var email = emailInput.value.trim();

        if (!email || !LS.isValidEmail(email)) {
          e.preventDefault();
          showError('Please enter a valid email address.');
          LS.fireEvent('popup_email_error', { popup_type: 'exit', error_type: 'invalid_email' });
          return;
        }

        /* Check disposable */
        await LS.loadDisposableDomains();
        if (LS.isDisposableEmail(email)) {
          e.preventDefault();
          showError('Please use a non-temporary email address.');
          LS.fireEvent('popup_email_error', { popup_type: 'exit', error_type: 'disposable_email' });
          return;
        }

        /* Valid — save state before Shopify form submits */
        LS.markSubmitted();
        LS.setLocal('liftsets_exit_email', email);

        if (isDiscount) {
          LS.setLocal('liftsets_discount_shown', '1');
        }

        /* Fire GA4 events */
        LS.fireEvent('popup_email_submitted', {
          popup_type: 'exit',
          variant: activeVariant,
          has_discount: isDiscount
        });
        LS.fireEnhancedConversion(email);

        /* Show loading state */
        submitBtn = document.getElementById('ls-exit-submit');
        btnText = overlay.querySelector('.ls-exit-btn-text');
        btnLoading = overlay.querySelector('.ls-exit-btn-loading');
        if (btnText) btnText.style.display = 'none';
        if (btnLoading) btnLoading.style.display = 'flex';
        if (submitBtn) submitBtn.disabled = true;

        /* Let Shopify form submit naturally (CAPTCHA handles it) */
      });
    }

    /* --- Detect returning from form submission --- */
    if (LS.hasSubmitted() && document.referrer.includes('/contact')) {
      /* Clean up hash */
      if (window.location.hash === '#contact_form') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    /* --- Exit detection --- */

    /* Desktop: Mouse leaves viewport top */
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && shouldShow()) {
        showExitIntent();
      }
    });

    /* Mobile: Visibility change (tab/app switch) */
    var exitQueued = false;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && shouldShow()) {
        exitQueued = true;
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && exitQueued) {
        exitQueued = false;
        showExitIntent();
      }
    });

    /* Mobile: Fast scroll up (back-to-top gesture) */
    var lastScrollY = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if (lastScrollY - y > 300 && y < 200 && shouldShow()) {
        showExitIntent();
      }
      lastScrollY = y;
    }, { passive: true });

    /* Track visits */
    LS.trackVisit();
  }

  /* --- Error display --- */
  function showError(msg) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }
    if (emailInput) {
      emailInput.style.borderColor = '#C8102E';
      emailInput.addEventListener('input', function () {
        emailInput.style.borderColor = '#ddd';
        if (errorEl) errorEl.style.display = 'none';
      }, { once: true });
    }
  }

  /* --- Start --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();